import { useEffect, useRef, useState } from "react";

// Drives the How It Works track: as the track scrolls through the
// viewport, computes 0-1 progress and derives which step is "active" and
// how far the fill line should extend. Same math as the mockup's
// updateHiw().
const useScrollProgress = (stepCount: number) => {
  const trackRef = useRef<HTMLDivElement | null>(null);
  const [activeStep, setActiveStep] = useState(0);
  const [fillPercent, setFillPercent] = useState(0);

  useEffect(() => {
    const update = () => {
      const track = trackRef.current;
      if (!track) return;

      const rect = track.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = Math.min(1, Math.max(0, (window.scrollY + vh * 0.5 - rect.top) / rect.height));
      const stepIndex = Math.min(stepCount - 1, Math.floor(progress * stepCount));

      setActiveStep(stepIndex);
      setFillPercent(Math.min(100, progress * 100));
    };

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    const timeout = setTimeout(update, 200);

    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      clearTimeout(timeout);
    };
  }, [stepCount]);

  return { trackRef, activeStep, fillPercent };
};

export default useScrollProgress;
